import { createApp } from 'vue';

import App from './App.vue';
import router from './router';

// Styles
import './assets/styles/app.scss';
import './assets/styles/scss/index.scss';
import '@synergy/ui-kit-vue3/dist/ui-kit.style.css';

import { UIKitPlugin } from '@synergy/ui-kit-vue3';

createApp(App).use(router).use(UIKitPlugin).mount('#app');
